export default {
  getRotas: state => state.rotas,
  getRotaSelecionada: state => state.rotaSelecionada,
  getTags: state => state.tags,
  getRotaUse: state => state.rotaUse,
  getGrupos: state => state.gruposRotas,
}
